import constate from "constate";
const useVirtualizedTablePropsContext = (props) => {
  return props;
};
const [VirtualizedTablePropsProvider, useVirtualizedTableProps] = constate(
  useVirtualizedTablePropsContext,
  (value) => value
);
export {
  VirtualizedTablePropsProvider,
  useVirtualizedTableProps
};
